import type { CatalogMaterial } from './materialCatalogGroups';
import { haulCategoryKey } from './materialCatalogGroups';

export type TypeFilter = 'all' | 'metal' | 'precious_gemstone' | 'semi_precious_gemstone' | 'mineral';

export const TYPE_FILTER_OPTIONS: { value: TypeFilter; label: string }[] = [
  { value: 'all', label: 'All types' },
  { value: 'metal', label: 'Metals' },
  { value: 'precious_gemstone', label: 'Precious gems' },
  { value: 'semi_precious_gemstone', label: 'Semi-precious' },
  { value: 'mineral', label: 'Minerals' },
];

function matchesSearch(m: CatalogMaterial, q: string): boolean {
  const needle = q.trim().toLowerCase();
  if (!needle) return true;
  if (m.displayName.toLowerCase().includes(needle)) return true;
  if (m.scientificName?.toLowerCase().includes(needle)) return true;
  for (const tok of m.synonymTokens ?? []) {
    if (tok.toLowerCase().includes(needle)) return true;
  }
  return false;
}

function matchesType(m: CatalogMaterial, type: TypeFilter): boolean {
  if (type === 'all') return true;
  if (type === 'mineral') return m.kind === 'mineral';
  return haulCategoryKey(m) === type;
}

export function filterMaterials(materials: CatalogMaterial[], search: string, type: TypeFilter): CatalogMaterial[] {
  return materials.filter((m) => matchesSearch(m, search) && matchesType(m, type));
}

export function filtersActive(search: string, type: TypeFilter): boolean {
  return search.trim().length > 0 || type !== 'all';
}

export function emptyFilterMessage(search: string, type: TypeFilter): string {
  const hasSearch = search.trim().length > 0;
  const hasType = type !== 'all';
  if (hasSearch && hasType) return 'No materials match your search and filters.';
  if (hasSearch) return 'No materials match your search.';
  if (hasType) {
    const label = TYPE_FILTER_OPTIONS.find((opt) => opt.value === type)?.label ?? 'selected type';
    return `No materials match the ${label.toLowerCase()} filter.`;
  }
  return 'No materials in the catalog.';
}
